import {
    clearTimeouts,
    engine as anime,
} from "../../../../../animations/index";
import { getTemplateDurationOveride } from "../../../../shared/utils/timeline";

const timeouts = [];

const main = (props) => {
    const timeouts = [];
    const { id, format, templateName, data } = props;

    const timeline = anime.timeline();
    const templateDuration = 10;
    // getTemplateDurationOveride({
    //     apiSetup: props?.apiSetup,
    //     tournamentId: props?.data?.event?.competitionId,
    //     fallback:
    //         _.find(props?.data?.data?.options, { id: "videoduration" })?.value || 0,
    //     templateName,
    //     event: data?.event
    // });
    $(`#${id} .ant-progress-bg`).css("width", "100%");
    $(`#${id} .ant-progress-bg`).css(
        "transition-duration",
        `${templateDuration}s`,
    );

    const timeout1 = setTimeout(() => {
        anime({
            targets: [`#${id} .table-head .col-points`],
            duration: 1000,
            easing: "easeOutQuint",
            opacity: [0, 1],
            delay: anime.stagger(100),
        });

        const rows = $(`#${id} .table-row`).get();
        rows.forEach((rowEl, index) => {
            const baseDelay = index * 200;
            // Animate children of that row
            anime({
                targets: $(rowEl).children().get(),
                duration: 800,
                easing: "easeOutQuint",
                opacity: [0, 1],
                delay: baseDelay + 200
            });
        });
    }, 600);

    timeouts.push(timeout1);

    return {
        timeline: [],
        timeouts,
    };
};

//clean up function, unmounting
export const animationCleanUp = (animationReturn) => {
    const { timeouts } = animationReturn;
    clearTimeouts(timeouts);
};

export default main;
